module.exports = __webpack_public_path__ + "img/lettClose.e19ee977.svg";